import { ResourceOptions } from 'react-admin';
import './dataProvider';
import { Resources } from '../resource';

export { default as list } from './NotificationConfigsPage';

export const name = Resources.notificationConfigs;
export const options: ResourceOptions = {
  label: 'resource.notificationConfigs',
};
